export const ReportMeasures = {
  AvgItemperSale: 3,
  AvgSaleValue: 4,
  AvgSaleValueInclTax: 5,
  CostofGoodsSold: 6,
  CustomerCount: 7,
  Discounted: 8,
  DiscountedPercentage: 9,
  FirstSale: 10,
  ItemSold: 11,
  LastSale: 12,
  MarginPercentage: 13,
  ReturnCount: 14,
  ReturnsPercentage: 15,
  Revenue: 16,
  RevenueInclTax: 17,
  SaleCount: 18,
  SaleswithCustomerPercentage: 19,
  Tax: 20,
  GrossProfit: 51,
  OnHandInventory: 52,
  LowInventory: 53,
  AllInventory: 54,
  Amount: 55,
};

export const SectionEnums = {
  SalePerformance: 1,
  AvgSaleValue: 2,
  GrossProfit: 3,
  AvgItemPerSale: 4,
  Revenue: 5,
  Discounted: 6,
  SalesWithCustomer: 7,
  TopProductSold: 8,
  SaleCount: 9,
  TopSalesPeople: 10
}

export const RetailMetricsMeasures = [
  {
    Key: SectionEnums.SalePerformance,
    Name: 'SalePerformance',
    DisplayName: 'dashboard.dashboardreporting.mysaleperformance',
    Description: 'dashboard.dashboardreporting.keeptrackofyourown',
    IsSelected: true,
    PeriodID: 1,
    MeasureID: 2,
    IsDisabled: true
  },
  {
    Key: SectionEnums.AvgSaleValue,
    Name: 'AvgSaleValue',
    DisplayName: 'dashboard.dashboardreporting.avgsalevalue',
    Description: 'dashboard.dashboardreporting.seetheaverage',
    IsSelected: false,
    PeriodID: 1,
    MeasureID: 2,
    IsDisabled: false
  },
  {
    Key: SectionEnums.GrossProfit,
    Name: 'GrossProfit',
    DisplayName: 'dashboard.dashboardreporting.grossprofit',
    Description: 'dashboard.dashboardreporting.keepaneyeonyour',
    IsSelected: true,
    PeriodID: 1,
    MeasureID: 2,
    IsDisabled: false
  },
  {
    Key: SectionEnums.AvgItemPerSale,
    Name: 'AvgItemPerSale',
    DisplayName: 'dashboard.dashboardreporting.avgitempersale',
    Description: 'dashboard.dashboardreporting.seetheaveragesold',
    IsSelected: false,
    PeriodID: 1,
    MeasureID: 2,
    IsDisabled: false
  },
  {
    Key: SectionEnums.Revenue,
    Name: 'Revenue',
    DisplayName: 'dashboard.dashboardreporting.revenue',
    Description: 'dashboard.dashboardreporting.getasnapshot',
    IsSelected: false,
    PeriodID: 1,
    MeasureID: 2,
    IsDisabled: false
  },
  {
    Key: SectionEnums.Discounted,
    Name: 'Discounted',
    DisplayName: 'dashboard.dashboardreporting.discounted',
    Description: 'dashboard.dashboardreporting.monitorthediscounts',
    IsSelected: false,
    PeriodID: 1,
    MeasureID: 2,
    IsDisabled: false
  },
  {
    Key: SectionEnums.SalesWithCustomer,
    Name: 'SalesWithCustomer',
    DisplayName: 'dashboard.dashboardreporting.saleswithcustomercard',
    Description: 'dashboard.dashboardreporting.trackthepercentage',
    IsSelected: false,
    PeriodID: 1,
    MeasureID: 2,
    IsDisabled: false
  },
  {
    Key: SectionEnums.TopProductSold,
    Name: 'TopProductSold',
    DisplayName: 'dashboard.dashboardreporting.topproductsold',
    Description: 'dashboard.dashboardreporting.easilyviewyour',
    IsSelected: true,
    PeriodID: 1,
    MeasureID: 2,
    IsDisabled: true
  },
  {
    Key: SectionEnums.SaleCount,
    Name: 'SaleCount',
    DisplayName: 'dashboard.dashboardreporting.salecount',
    Description: 'dashboard.dashboardreporting.watchhowmanysalesare',
    IsSelected: false,
    PeriodID: 1,
    MeasureID: 2,
    IsDisabled: false
  },
  {
    Key: SectionEnums.TopSalesPeople,
    Name: 'TopSalesPeople',
    DisplayName: 'dashboard.dashboardreporting.topsalespeoplecard',
    Description: 'dashboard.dashboardreporting.easilyviewbestperforming',
    IsSelected: false,
    PeriodID: 1,
    MeasureID: 2,
    IsDisabled: false
  }
]